var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityConnectSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3831_11903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 8.0004H9.42813C8.45789 7.98702 7.5134 8.31269 6.75761 8.92122C6.00181 9.52975 5.4821 10.383 5.28813 11.3337H1.32812V12.6671H5.28146C5.47203 13.6207 5.99174 14.4771 6.74974 15.0864C7.50773 15.6957 8.45577 16.0192 9.42813 16.0004H11.3281V8.0004Z",
    fill: "#8494AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8174 11.3339C18.623 10.3809 18.1013 9.52592 17.3428 8.91712C16.5842 8.30833 15.6366 7.98409 14.6641 8.0006H12.6641V16.0006H14.6641C15.6364 16.0195 16.5845 15.6959 17.3425 15.0866C18.1004 14.4773 18.6202 13.6209 18.8107 12.6673H22.6641V11.3339H18.8174Z",
    fill: "#8494AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3831_11903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityConnectSolid);
export default __webpack_public_path__ + "static/media/clarity_connect-solid.62c5355728551048565d320f80664998.svg";
export { ForwardRef as ReactComponent };